import {accessToken} from "../components/core/auth-service/auth-service";
import getConfig from '../environment';
import {ImpersonationSearchRequest} from "../model/ImpersonationSearchRequest";

const IMPERSONATION_SEARCH_API = getConfig()?.impersonationSearchApi;

export async function getImpersonationSearchResults(requestData:ImpersonationSearchRequest, baseSiteUID: string, salesAreaDependentCustomerUid: string) {
  const url = `${IMPERSONATION_SEARCH_API}${requestData.toQueryString()}`;
  return fetch(url, {
    headers: {
      'Authorization': `Bearer ${await accessToken()}`,
      'Accept': 'application/json',
       "PT-Base-Site-UID": baseSiteUID,
       "PT-Sales-Area-Dependent-Customer-Uid": salesAreaDependentCustomerUid ?? "null",
    }
  }).then(response => {
    if(response.ok) {
      return response.json();
    }
  })
}
